import { connect } from 'react-redux';
import { isHyper } from 'web/store/modules/user';
import { getCompanySettingsUrl, getStorEdgeUrl } from 'web/store/modules/company';
import AdminNavbarItem from '../components/AdminNavbarItem';

const mapStateToProps = state => ({
  companySettingsUrl: getCompanySettingsUrl(state),
  hyperUser: isHyper(state),
  storEdgeUrl: getStorEdgeUrl(state),
});

const mapDispatchToProps = null;

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { companySettingsUrl, hyperUser, storEdgeUrl } = stateProps;

  return {
    ...ownProps,
    pull: 'bottom',
    icon: 'corporate',
    hideUnauthorized: true,
    text: hyperUser ? 'FMS Hyper' : 'storEDGE Software',
    href: hyperUser ? companySettingsUrl : storEdgeUrl,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(AdminNavbarItem);
